import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_sniperb3.png",
      alt: "Estratégias SniperB3",
    },
    title: "Opere com quem mais entende de Fluxo Financeiro",

    // String ou array de strings
    text: "Com profissionais com mais de 15 anos de mercado, atuando em corretoras e mesas de negociação, bem como desenvolvendo e treinando os inúmeros traders profissionais, viemos trazer para os clientes uma maneira de operar através de análise quantitativa e reativa as melhores regiões de liquidez do mercado. Conheça o privilégio de assinar uma estratégia que se preocupa com seu capital e sua segurança em um mercado tão volátil e agressivo.",
    testimonial: {
      text: "Metodologia flexível e auto-ajustável ao comportamento do mercado. Alvo longo, stop curto.",
      author: {
        name: "Diogo P.J Manoel . Head de Estratégias SniperB3 / I9 Quant",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Diogo P .J Manoel",
    heading: "REMORA MODERADO - ÍNDICE",
    subtitle:
      "Estratégia se baseia em executar posições quando os Market Makers estiverem agredindo uma região de valor ou exaustão dada a liquidez, zeragem, stops ou troca de lotes.",
  },

  cta: {
    title: "Pronto para ter uma nova experiência e gestão de ganhos?",
    subtitle: "Ative agora mesmo e surpreenda-se",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A SniperB3",
    col1: [
      "Proporcionamos aos clientes Sniper B3 acesso a um conhecimento rico em detalhes, uma metodologia inédita simples de ser compreendida e aplicada, tudo isso graças suíte de indicadores exclusivos Sniper, solução tecnológica desenvolvida exclusivamente pela nossa empresa, comprovadamente capaz de atender traders iniciantes ou traders experientes que operam no mercado de renda variável.",
    ],
    col2: [
      "Desta forma, a Sniper B3 se torna uma empresa diferenciada trazendo produtos educacionais tanto para Day Trade quanto para Swing Trade, refinando a sua análise para cenários presentes e futuros. Com o que tem de melhor em automação.",
    ],
  },

  stats: {
    title: "Números",
    subtitle:
      "Não perca tempo e comece a operar os ativos mais líquidos com o melhor do quant trade.",
    data: [
      {
        value: "+14",
        description: "Anos no mercado",
      },
      {
        value: "230",
        description: "Clientes",
      },
      {
        value: "+3 mi",
        description: "Ordens por ano.",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da SniperB3?",
    subtitle: "Veja quais as principais vantagens dos robôs da SniperB3.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão SniperB3",
  },

  testimonials: [
    {
      text: "Entre tantos traders e empresas do mercado financeiro não há igual ao mestre a Sniper B3. O por quê? Porque sabe o que faz, demonstra como faz, além de aprensentar consistências nos resultados. Na Sniper B3 aprendemos de fato como enxergar o mercado com os ensinamentos conscientemente concretos, e claro,  fazendo uso da melhor ferramenta desse nosso Brasil: A Sniper B3",
      author: "Ramon Carvalho",
      job: "Trader - Químico",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "A Sniper B3 é um produto que  revolucionou  o meu  operacional.  Essa técnica é inovadora, sendo certeira na indicação das entradas e saídas!  Fico feliz em fazer parte da Revolução do mercado financeiro de soluções quantitativas de verdade.",
      author: "Douglas Sousa",
      job: "Trader (TOP GAIN)",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
